/* eslint-disable no-alert */
import React, { useEffect, useState } from 'react';
import { LoadingOverlay } from '@uhg-abyss/web/ui/LoadingOverlay';
import { Button } from '@uhg-abyss/web/ui/Button';
import { Card } from '@uhg-abyss/web/ui/Card';
import { clearLoginRequestFromStorage, clearTokenFromStorage, saveLoginRequestToStorage } from '@src/utills/storage';
import { API } from '@src/api';

export const Login = () => {
  const [overlayState, setOverlayState] = useState({
    isOpen: true,
    isLoading: true,
    loadingTitle: 'Please wait',
    loadingMessage: 'Retrieving Information.',
    statusTitle: '',
    statusMessage: '',
  });
  useEffect(() => {
    clearLoginRequestFromStorage();
    clearTokenFromStorage();

    API.uhcSsoLogin().then((resp) => {
      try {
        // Error out if we didn't get a successful response
        if (resp === null) {
          throw new Error("Could not authenticate via SSO!");
        }

        if (resp !== null && resp.request_id) {
          saveLoginRequestToStorage(resp.request_id);
        }

        setOverlayState({
          isOpen: false,
          isLoading: false,
          loadingTitle: 'Authentication is success',
          loadingMessage: '',
        });

        if (resp !== null && resp.url) {
          window.location.href = resp.url;
        }

      } catch (error: any) {
        console.error("Just caught an error from our session login!");
        setOverlayState({
          isOpen: true,
          isLoading: false,
          loadingTitle: 'Authentication Failed',
          loadingMessage: 'Unable to authenticate. Please try again or contact support.',
          statusTitle: 'Authentication Failed',
          statusMessage: 'Unable to authenticate. Please try again or contact support.',
        });
      }
    });
  }, []);
  return (
    <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh' }}>
      <LoadingOverlay
        isOpen={overlayState.isOpen}
        isLoading={overlayState.isLoading}
        loadingTitle={overlayState.loadingTitle}
        loadingMessage={overlayState.loadingMessage}
        statusTitle={overlayState.statusTitle}
        statusMessage={overlayState.statusMessage}
      />
    </div>
  );
};
